import { z } from 'zod';

import { DataSourceDetailsSchema } from '../data-sources/data-sources.schema';

export const SyncSharepointResponseSchema = z.object({
  dataSources: DataSourceDetailsSchema.array(),
  syncError: z.enum(['files', 'pages', 'both']).nullable(),
});

export type TSyncSharepointResponse = z.infer<
  typeof SyncSharepointResponseSchema
>;

export const DownloadSharepointFileSchema = z.object({
  fileName: z.string(),
  fileType: z.string(),
  fileBuffer: z.string(),
});

export type TDownloadSharepointFileSchema = z.infer<
  typeof DownloadSharepointFileSchema
>;
